import React from "react";
import { Phone, Mail, MapPin, ArrowUp } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_beaf72ee-9408-4045-89da-ab09df8a27f4/artifacts/r8zr67a7_ChatGPT%20Image%20Mar%2027%2C%202026%2C%2002_31_30%20AM.png";

const footerLinks = [
  {
    title: "Programs",
    links: ["Core Build", "Shred Season", "Hybrid Grind", "Starter Mode"],
  },
  {
    title: "Classes",
    links: ["Boxing", "Yoga", "HYROX", "Dance", "Zumba"],
  },
  {
    title: "Company",
    links: ["About Us", "Facilities", "Pricing", "Contact"],
  },
];

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleLinkClick = (label) => {
    const sectionMap = {
      "About Us": "#about",
      "Facilities": "#facilities",
      "Pricing": "#pricing",
      "Contact": "#contact",
      "Boxing": "#classes",
      "Yoga": "#classes",
      "HYROX": "#classes",
      "Dance": "#classes",
      "Zumba": "#classes",
      "Core Build": "#pricing",
      "Shred Season": "#pricing",
      "Hybrid Grind": "#pricing",
      "Starter Mode": "#pricing",
    };
    const target = sectionMap[label];
    if (target) {
      const el = document.querySelector(target);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-[#262626]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img src={LOGO_URL} alt="Core Culture" className="h-10 w-10 object-contain" />
              <span className="font-['Bebas_Neue'] text-2xl tracking-wider text-white">CORE CULTURE</span>
            </div>
            <p className="text-sm text-[#A3A3A3] leading-relaxed mb-6 max-w-sm">
              A next-generation fitness space where consistency becomes identity. Train hard, look good, build discipline.
            </p>
            <div className="space-y-3">
              <a href="tel:8826033661" className="flex items-center gap-3 text-sm text-[#A3A3A3] hover:text-[#F59E0B] transition-colors">
                <Phone size={14} />
                +91 8826033661
              </a>
              <a href="mailto:contact@rmwebworks.in" className="flex items-center gap-3 text-sm text-[#A3A3A3] hover:text-[#F59E0B] transition-colors">
                <Mail size={14} />
                contact@rmwebworks.in
              </a>
              <div className="flex items-start gap-3 text-sm text-[#A3A3A3]">
                <MapPin size={14} className="mt-0.5 flex-shrink-0" />
                <span>Block C, Connaught Place, New Delhi</span>
              </div>
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-['Bebas_Neue'] text-lg tracking-wider text-white mb-5">{group.title}</h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link}>
                    <button
                      onClick={() => handleLinkClick(link)}
                      className="text-sm text-[#A3A3A3] hover:text-[#F59E0B] transition-colors duration-300"
                    >
                      {link}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-[#262626] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#555]">
            &copy; {new Date().getFullYear()} Core Culture. All rights reserved.
          </p>
          <button
            data-testid="scroll-to-top"
            onClick={scrollToTop}
            className="flex items-center gap-2 text-xs text-[#A3A3A3] hover:text-[#F59E0B] transition-colors uppercase tracking-wider"
          >
            Back to top
            <ArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
}
